export default "__VITE_ASSET__85deefa9__"